export const reportsKeys = {
  all: ['reports'] as const,
  metadataList: () => [...reportsKeys.all, 'metadataList'] as const,
  thoughtSpotToken: (userId: string) =>
    [...reportsKeys.all, 'thoughtSpotToken', userId] as const,
  metabaseDashboardUrl: (dashboardId: string, accountId: string) =>
    [
      ...reportsKeys.all,
      'metabaseDashboardUrl',
      dashboardId,
      accountId,
    ] as const,
}
